import { render, staticRenderFns } from "./BFieldNumber.vue?vue&type=template&id=e0fcb4e0&"
import script from "./BFieldNumber.vue?vue&type=script&lang=js&"
export * from "./BFieldNumber.vue?vue&type=script&lang=js&"
import style0 from "./BFieldNumber.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports